import { manageOverlay } from "Components/overlaysContext/overlaysManager";
import withOverlaysContext from "Components/overlaysContext/withOverlaysContext";
import classNames from "classnames";
import { Popover as DxPopover } from "devextreme-react/popover";
import map from "lodash/map";
import pickBy from "lodash/pickBy";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { v4 as uuid } from "uuid";
function Popover(props) {
    const { popoverContent, popoverTitle, popoverId, target, showEvent, hideEvent, position, forwardedRef, popoverRef: propsPopoverRef, onShowing, onHidden, toolbarItems, disabled, container, popoverClassName, popoverWidth, popoverHeight, popoverMaxWidth, popoverMinWidth, popoverMaxHeight, popoverMinHeight, overlaysManager, getOverlaysContainer, zIndex, onHiding, defaultVisible, visible, animation, ...other } = props;
    const defaultPopoverRef = useRef(null);
    const popoverRef = propsPopoverRef || defaultPopoverRef;
    const wrapperAttr = useMemo(() => ({
        id: popoverId || `popoverId_${uuid()}`,
        class: classNames(popoverClassName, "invisible-popover-arrow"),
        zIndex
    }), [popoverId, popoverClassName, zIndex]);
    useEffect(() => () => {
        manageOverlay(popoverRef.current, overlaysManager, false);
    }, []);
    const handleShowing = useCallback((e) => {
        manageOverlay(popoverRef.current, overlaysManager, true);
        onShowing && onShowing(e);
    }, [onShowing]);
    const handleHidden = useCallback((e) => {
        manageOverlay(popoverRef.current, overlaysManager, false);
        onHidden && onHidden(e);
    }, [onHidden]);
    const renderContent = useCallback(() => popoverContent, [popoverContent]);
    useEffect(() => {
        var _a;
        if (!props.ignoreHidingWhenChanged &&
            ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) &&
            popoverRef.current.instance.option("visible")) {
            popoverRef.current.instance.hide();
        }
    }, map(other));
    const hasContent = useMemo(() => Boolean(popoverContent), [popoverContent]);
    useEffect(() => {
        var _a;
        if (hasContent && ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance)) {
            popoverRef.current.instance.option("disabled", disabled);
            popoverRef.current.instance.hide();
        }
    }, [hasContent, disabled]);
    const dxVisibleProps = useMemo(() => {
        const result = { defaultVisible, visible };
        return pickBy(result);
    }, [defaultVisible, visible]);
    return hasContent ? (React.createElement(DxPopover, { ref: popoverRef, wrapperAttr: wrapperAttr, target: target, container: container, position: position, showEvent: showEvent, hideEvent: hideEvent, onShowing: handleShowing, onHidden: handleHidden, onHiding: onHiding, title: popoverTitle, showTitle: Boolean(popoverTitle), contentRender: renderContent, deferRendering: false, showCloseButton: false, width: popoverWidth, height: popoverHeight, minWidth: popoverMaxWidth, maxWidth: popoverMinWidth, maxHeight: popoverMaxHeight, minHeight: popoverMinHeight, hideOnParentScroll: props.hideOnParentScroll, hideOnOutsideClick: props.hideOnOutsideClick, animation: animation, ...dxVisibleProps }, toolbarItems)) : null;
}
Popover.defaultProps = {
    hideOnParentScroll: true,
    defaultVisible: false,
    showEvent: "click",
    position: "bottom",
    container: document.body
};
export default withOverlaysContext(Popover);
